/**
 * Determine if a range intersects a point
 * @param {number} p the intersection point
 * @param {number} y1 the range start point
 * @param {number} y2  the range end point
 */
export default function intersects(p: number, y1: number, y2: number): boolean {
  return y1 <= p && y2 > p;
}
